import { Button } from '@mui/material';
import React, { useState } from 'react';
import { ILegalClient } from '../../../Interfaces/ILegalClient';
import { ILegalRole } from '../../../Interfaces/ILegalRole';
import { ILegalRole_canInvite } from '../../../Interfaces/ILegalRole_canInvite';
import { FullScreenDialog } from '../../../core/FullScreenDialog';
import { LegalRoleCanInviteTable } from './LegalRoleCanInviteTable';
import { LegalRoleOverview } from './LegalRoleOverview';

interface IProps {
  takenLegalClients: ILegalClient[];
  legalRoles: ILegalRole[];
  setLegalRoles: React.Dispatch<React.SetStateAction<ILegalRole[]>>;
  legalRoleCanInviteMap: ILegalRole_canInvite[];
  setLegalRoleCanInviteMap: React.Dispatch<
    React.SetStateAction<ILegalRole_canInvite[]>
  >;
}

export const LegalRoleEditDialog: React.FC<IProps> = ({
  takenLegalClients,
  legalRoles,
  setLegalRoles,
  legalRoleCanInviteMap,
  setLegalRoleCanInviteMap,
}) => {
  const [editedLegalRoles, setEditLegalRoles] = useState(legalRoles);
  const [editLegalRoleCanInviteMap, setEditLegalRoleCanInviteMap] = useState(
    legalRoleCanInviteMap
  );

  const [isOpenDialog, setIsOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setEditLegalRoles(legalRoles);
    setEditLegalRoleCanInviteMap(legalRoleCanInviteMap);
    setIsOpenDialog(true);
  };

  const handleSave = () => {
    setLegalRoles(editedLegalRoles);
    setLegalRoleCanInviteMap(editLegalRoleCanInviteMap);
    setIsOpenDialog(false);
  };

  return (
    <>
      <Button
        sx={{ float: 'right' }}
        variant='outlined'
        onClick={handleOpenDialog}
      >
        Rollen anpassen
      </Button>

      <FullScreenDialog
        isOpen={isOpenDialog}
        onClose={() => setIsOpenDialog(false)}
        title='Rollen bearbeiten'
      >
        <>
          <Button
            sx={{ float: 'right' }}
            variant='contained'
            onClick={handleSave}
          >
            Übernehmen
          </Button>
          <LegalRoleOverview
            newClients={takenLegalClients}
            legalRoles={editedLegalRoles}
            setLegalRoles={setEditLegalRoles}
          />

          <LegalRoleCanInviteTable
            legalRoles={editedLegalRoles}
            legalRoleCanInviteMap={editLegalRoleCanInviteMap}
            setLegalRoleCanInviteMap={setEditLegalRoleCanInviteMap}
          />
        </>
      </FullScreenDialog>
    </>
  );
};
